import { render, staticRenderFns } from "./OutDetail.vue?vue&type=template&id=6530879a&scoped=true"
import script from "./OutDetail.vue?vue&type=script&lang=js"
export * from "./OutDetail.vue?vue&type=script&lang=js"
import style0 from "./OutDetail.vue?vue&type=style&index=0&id=6530879a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530879a",
  null
  
)

export default component.exports